import { Button } from '@material-ui/core';
import { ICustomButton } from './CustomButtonTypes';
import React from 'react';
import { customButtonStyles } from './CustomButton.style';

const getButtonProps = (buttonType: string) => {
	const classes = customButtonStyles();
	switch (buttonType) {
		case 'primary':
			return {
				className: classes.primary,
				variant: 'contained',
			};
		case 'primaryXL':
			return {
				className: `${classes.primary} ${classes.xl}`,
				variant: 'contained',
			};
		case 'secondary':
			return {
				className: classes.secondary,
				variant: 'contained',
			};
		case 'secondaryXL':
			return {
				className: `${classes.secondary} ${classes.xl}`,
				variant: 'contained',
			};
		default:
			return {};
	}
};

const CustomButton: React.FC<ICustomButton> = ({
	text,
	buttonType,
	onClick,
	id,
	icon,
	fullWidth,
	classes,
	...other
}) => {
	const buttonProps = getButtonProps(buttonType);
	return (
		<Button
			className={`${buttonProps.className} ${classes}`}
			variant={buttonProps.variant}
			onClick={onClick}
			endIcon={icon}
			fullWidth={fullWidth}
			{...other}
		>
			{text}
		</Button>
	);
};

export default CustomButton;
